module.exports = __webpack_public_path__ + "static/portfolio-image-10-6ecb13cbaa26cad9f4253e3e5e84a525.jpg";